<template>
  <div id="app">
    <router-view v-if="isPhoneDevice" />

    <!-- 电脑端提示遮罩 -->
    <PcTip v-else :qr-code="qrCodeUrl" />
  </div>
</template>

<script>
import PcTip from "@/components/PcTip.vue";

export default {
  components: { PcTip },
  data() {
    return {
      isPhoneDevice: true,
      qrCodeUrl: require('@/assets/qrcode.png')
    };
  },
  created() {
    this.isPhoneDevice = true; // this.isPhone();
  },
  methods: {
    isPhone() {
      // UA 说是手机，但再做一层平台校验，拦住手动改 UA 的情况
      // 真实 iPhone → navigator.platform = "iPhone"
      // 真实安卓  → navigator.platform 通常是 "Linux armv8l" / "Linux armv7l"
      // 桌面 Chrome F12 改 UA → navigator.platform 仍是 "Win32" / "MacIntel"
      const platform = navigator.platform || "";
      const isRealMobilePlatform =
        /iphone|iPhone|ipod|ipad|android|linux arm|linux aarch/i.test(platform);
      if (isRealMobilePlatform === false) return false;

      // Chrome/Edge 90+：优先用 Client Hints（关键）
      if (navigator.userAgentData) {
        // 真实安卓 Chrome → true
        // 桌面 Chrome（无论 UA 怎么改）→ false
        if (navigator.userAgentData.mobile === false) return false;
      }

      // 没有 userAgentData 的浏览器（Safari、旧版安卓）→ 回退 UA
      const ua = navigator.userAgent;
      const uaMobile =
        /android|iphone|ipod|blackberry|iemobile|opera mini|mobile|windows phone/i.test(
          ua,
        );
      if (!uaMobile) return false;

      return true;
    },
  },
};
</script>

<style lang="less">
#app {
  font-family: -apple-system-font, BlinkMacSystemFont, "Helvetica Neue",
    "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei UI", "Microsoft YaHei",
    Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  touch-action: manipulation;
  text-align: center;
  width: 100%;
  display: flex;
  justify-content: center;
}

html,
body {
  width: 100%;
  margin: 0;
  padding: 0;
  background-color: rgb(42, 38, 50);
}
</style>
